<template>
    <div class="p-3">
        <div class="d-flex justify-content-start align-items-center gap-5 mb-5">
            <div class="d-flex align-items-center form-check form-switch filter_switch">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="showVehicles"
                    v-model="showVehicles"
                >
                <label class="form-check-label fw-bold" for="showVehicles">
                    {{ $t("vehicleEntry.vehicles") }}
                </label>
            </div>

            <div class="d-flex align-items-center form-check form-switch filter_switch">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="showGuestbooks"
                    v-model="showGuestbooks"
                >
                <label class="form-check-label fw-bold" for="showGuestbooks">
                    {{ $t("guestbook.visitors") }}
                </label>
            </div>
        </div>
        <FullCalendar id="calendar" ref="calendar" :options="calendarOptions">
            <template v-slot:eventContent='arg'>
                <span class="calendar-text" v-if="arg.event.extendedProps.licence_plate">
                    Vozidlo:<br><b>{{ arg.event.extendedProps.licence_plate }}</b><br>
                    Dopravce:<br><b>{{ arg.event.extendedProps.carrier }}</b><br>
                    <span v-for="(commodity, index) in  arg.event.extendedProps.commodities">
                        <span><b><span v-if="commodity.note">{{ commodity.note }},</span> {{ commodity.quantity }} {{ commodity.unit_name }}</b></span>
                        <br v-if="index != Object.keys(arg.event.extendedProps.commodities).length - 1">
                    </span>
                </span>
                <span class="calendar-text" v-else>
                    Jméno:<br><b>{{ arg.event.extendedProps.guest_name }}</b><br>
                    Firma:<br><b>{{ arg.event.extendedProps.company }}</b><br>
                    Číslo karty:<br><b>{{ arg.event.extendedProps.personal_card_number }}</b>
                </span>
            </template>
        </FullCalendar>
    </div>

    <!-- Modal for VehicleEntry event -->
    <teleport to="body">
        <div class=" modal modal-lg fade" id="vehicleModal" tabindex="-1" aria-hidden="true" ref="vehicleModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal_wrapper">
                    <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                        <h3 class="modal-title">{{ $t("headers.vehicleDetail") }}</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="selectedEvent">
                            <dl class="row mb-0 mx-3">
                                <dt class="col-sm-4">{{ $t("vehicleEntry.carrier") }}</dt>
                                <dd class="col-sm-8">{{ selectedEvent.carrier }}</dd>

                                <dt class="col-sm-4">{{ $t("vehicleEntry.driver_name") }}</dt>
                                <dd class="col-sm-8">{{ selectedEvent.driver_name || "-" }}</dd>

                                <dt class="col-sm-4">{{ $t("vehicleEntry.licencePlate") }}</dt>
                                <dd class="col-sm-8">{{ selectedEvent.licence_plate }}</dd>

                                <dt class="col-sm-4">
                                    <span v-if="selectedEvent.actual_from">
                                        {{ $t("vehicleEntry.from") }}
                                    </span>
                                    <span v-else>{{ $t("vehicleEntry.expectedFrom") }}</span>
                                </dt>
                                <dd class="col-sm-8">
                                    <span v-if="selectedEvent.actual_from">
                                        {{ $d(new Date(selectedEvent.actual_from), 'short') }}
                                    </span>
                                    <span v-else-if="selectedEvent.expected_from">
                                        {{ $d(new Date(selectedEvent.expected_from), 'short') }}
                                    </span>
                                    <span v-else>-</span>
                                </dd>

                                <dt class="col-sm-4">
                                    <span v-if="selectedEvent.actual_to">
                                        {{ $t("vehicleEntry.to") }}
                                    </span>
                                    <span v-else>{{ $t("vehicleEntry.expectedTo") }}</span>
                                </dt>
                                <dd class="col-sm-8">
                                    <span v-if="selectedEvent.actual_to">
                                        {{ $d(new Date(selectedEvent.actual_to), 'short') }}
                                    </span>
                                    <span v-else-if="selectedEvent.expected_to">
                                        {{ $d(new Date(selectedEvent.expected_to), 'short') }}
                                    </span>
                                    <span v-else>—</span>
                                </dd>
                            </dl>

                            <h3 class="mb-3 mt-4 text-center">{{ $t("commodity.modalLabel") }}</h3>
                            <div v-if="selectedEvent.commodities && selectedEvent.commodities.length">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th class="w-50">{{ $t("commodity.name") }}</th>
                                            <th class="w-25">{{ $t("commodity.quantity") }}</th>
                                            <th class="w-25">{{ $t("commodity.end_quantity") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in selectedEvent.commodities" :key="index">
                                            <td class="w-50">{{ item.name }}</td>
                                            <td class="w-25">{{ item.quantity }}<br>{{ item.unit_name }}</td>
                                            <td class="w-25">
                                                <span v-if="selectedEvent.status_name == 'left'">{{ item.end_quantity }}<br></span>
                                                <input :value="item.end_quantity" @change="(event) => { changeCommodityReal(item.id, event.target.value) }" type="number" min="0" class="form-control border border-dark" v-else/>
                                                {{ item.unit_name }}
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else class="text-center">
                                <em>{{ $t("commodity.warning") }}</em>
                            </div>

                            <h3 class="mb-3 mt-4 text-center">{{ $t("status.status") }}</h3>
                            <StatusSelector
                                :record="selectedEvent"
                                statusType="vehicleEntry"
                                modalId="vehicleModal"
                                :getUrl="`/${$route.params.slug}/statuses?model=vehicleentry`"
                                :submitUrl="`/${$route.params.slug}/vehicle-entries/${selectedEvent.id}/status/edit`"
                                @status-updated="updateCalendarEvent"
                            />
                        </div>
                    </div>
                    <div class="modal-footer border-0 d-flex justify-content-between">
                        <button
                            class="btn btn-primary"
                            @click="goToDetail(selectedEvent)"
                        >
                            <span class="fs-6 fw-bold">{{ $t("utils.goToDetail") }}</span>
                        </button>
                        <button
                            class="btn btn-danger"
                            @click="showDelete()"
                            data-bs-dismiss="modal"
                            v-if="selectedEvent && selectedEvent.status_name == 'reserved'"
                        >
                            <span class="fs-6 fw-bold">{{ $t("utils.delete") }}</span>
                        </button>
                        <button
                            v-if="canEdit"
                            class="btn btn-primary"
                            @click="goToEdit(selectedEvent)"
                        >
                            <span class="fs-6 fw-bold">{{ $t("utils.editDetails") }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </teleport>

    <!-- Modal for Guestbook event -->
    <teleport to="body">
        <div class="modal fade" id="guestbookModal" tabindex="-1" aria-hidden="true" ref="guestbookModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal_wrapper">
                    <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                        <h3 class="modal-title">{{ $t("headers.guestbookDetail") }}</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="selectedEvent">
                            <dl class="row mb-0">
                                <dt class="col-sm-4">{{ $t("guestbook.name") }}</dt>
                                <dd class="col-sm-8">{{ selectedEvent.guest_name }}</dd>

                                <dt class="col-sm-4">{{ $t("guestbook.company") }}</dt>
                                <dd class="col-sm-8">{{ selectedEvent.company }}</dd>

                                <dt class="col-sm-4">{{ $t("guestbook.cardNumber") }}</dt>
                                <dd class="col-sm-8">{{ selectedEvent.personal_card_number }}</dd>

                                <dt class="col-sm-4">{{ $t("guestbook.cardType") }}</dt>
                                <dd class="col-sm-8">
                                    {{ selectedEvent.personal_card_type ? $t("documentType." + selectedEvent.personal_card_type) : "-" }}
                                </dd>

                                <dt class="col-sm-4">
                                    <span v-if="selectedEvent.actual_from">
                                        {{ $t("guestbook.from") }}
                                    </span>
                                    <span v-else>{{ $t("guestbook.expectedFrom") }}</span>
                                </dt>
                                <dd class="col-sm-8">
                                    <span v-if="selectedEvent.actual_from">
                                        {{ $d(new Date(selectedEvent.actual_from), 'short') }}
                                    </span>
                                    <span v-else-if="selectedEvent.expected_from">
                                        {{ $d(new Date(selectedEvent.expected_from), 'short') }}
                                    </span>
                                    <span v-else>-</span>
                                </dd>

                                <dt class="col-sm-4">{{ $t("guestbook.to") }}</dt>
                                <dd class="col-sm-8">
                                    {{ selectedEvent.actual_to ? $d(new Date(selectedEvent.actual_to), 'short') : "-" }}
                                </dd>

                            </dl>
                            <h3 class="mb-3 text-center">{{ $t("status.status") }}</h3>
                            <StatusSelector
                                :record="selectedEvent"
                                statusType="guestbook"
                                modalId="guestbookModal"
                                :getUrl="`/${$route.params.slug}/statuses?model=guestbook`"
                                :submitUrl="`/${$route.params.slug}/guestbooks/${selectedEvent.id}/status/edit`"
                                @status-updated="updateCalendarEvent"
                            />
                        </div>
                    </div>
                    <div class="modal-footer border-0 d-flex justify-content-between">
                        <button
                            class="btn btn-primary"
                            @click="goToDetail(selectedEvent)"
                        >
                            <span class="fs-6 fw-bold">{{ $t("utils.goToDetail") }}</span>
                        </button>
                        <button
                            v-if="canEdit"
                            class="btn btn-primary"
                            @click="goToEdit(selectedEvent)"
                        >
                            <span class="fs-6 fw-bold">{{ $t("utils.editDetails") }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
    <VehicleEntryDeleteModal v-if="selectedEvent" :vehicleEntry="selectedEvent" ref="deleteModal" />
</template>

<script>
    import FullCalendar from "@fullcalendar/vue3";
    import dayGridPlugin from "@fullcalendar/daygrid";
    import interactionPlugin from "@fullcalendar/interaction";
    import timeGridPlugin from "@fullcalendar/timegrid";
    import multiMonthPlugin from "@fullcalendar/multimonth";
    import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
    import StatusSelector from "@/components/StatusSelector.vue";
    import VehicleEntryDeleteModal from "@/components/VehicleEntryDeleteModal.vue";

    export default {
        components: {
            FullCalendar,
            StatusSelector,
            VehicleEntryDeleteModal
        },
        data() {
            return {
                showVehicles: true,
                showGuestbooks: true,
                selectedEvent: null,
                vehicleModal: null,
                guestbookModal: null,
                refreshInterval1: null,
                refreshInterval2: null,
                lastCheck: null,
                calendarDate: null,
                calendarOptions: {
                    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, multiMonthPlugin],
                    initialView: "timeGridDay",
                    height: "auto",
                    locale: "cs",
                    firstDay: "1",
                    selectable: true,
                    editable: true,
                    eventDurationEditable: true,
                    eventStartEditable: true,
                    nowIndicator: true,
                    headerToolbar: {
                        start: "today prev,next",
                        center: "title",
                        right: "timeGridDay",
                    },
                    buttonText: {
                        today: "Dnes",
                        day: "Den",
                        week: "Týden",
                        month: "Měsíc",
                        year: "Rok",
                    },
                    allDayText: "",
                    views: {
                        timeGridWeek: {
                            slotLabelFormat: { hour: "2-digit", minute: "2-digit", hour12: false }
                        },
                        timeGridDay: {
                            slotLabelFormat: { hour: "2-digit", minute: "2-digit", hour12: false }
                        }
                    },
                    dayHeaderFormat: { weekday: "short" },
                    dayHeaderContent: (args) => {
                        const date = args.date;
                        const dayName = args.text.charAt(0).toUpperCase() + args.text.slice(1);
                        const dayNumber = date.getDate();

                        return {
                            html: `<div>${dayName}</div><div style="font-size: 1.3em; ">${dayNumber}</div>`
                        };
                    },
                    slotDuration: "00:30:00",
                    slotLabelInterval: "00:30:00",
                    slotLabelFormat: {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false
                    },
                    eventClick:this.handleEventClick,
                    eventDrop: this.handleEventDrop,
                    eventResize: this.handleEventDrop,
                    events: [],
                }
            }
        },
        mounted() {
            const vehicles = localStorage.getItem("showVehicles")
            const guestbooks = localStorage.getItem("showGuestbooks")

            if (vehicles !== null) {
                this.showVehicles = vehicles === "true"
            }

            if (guestbooks !== null) {
                this.showGuestbooks = guestbooks === "true"
            }

            this.vehicleModal = new Modal(this.$refs.vehicleModal, { backdrop: "static"});
            this.guestbookModal = new Modal(this.$refs.guestbookModal, { backdrop: "static"});

            this.getCalendarEvents();

            this.refreshInterval1 = setInterval(() => {
                var getData = new Date();
                getData.setHours(getData.getHours() - 3); //get data for last 3 hours
                this.getCalendarEvents(getData);
            }, 3000);

            this.refreshInterval2 = setInterval(() => {
                this.getCalendarEvents();
            }, 30000);
        },
        beforeUnmount() {
            if (this.vehicleModal) this.vehicleModal.hide();
            if (this.guestbookModal) this.guestbookModal.hide();
            clearInterval(this.refreshInterval1);
            clearInterval(this.refreshInterval2);
        },
        methods: {
            getCalendarEvents(lastCheck) {
                const slug = this.$route.params.slug;
                var date = this.getDate();
                var time = "?expected_from_date=" + date;
                if (this.calendarDate && this.calendarDate === date && lastCheck) {
                    time += "&t=" + lastCheck.toISOString();
                }
                this.calendarDate = date;

                Promise.all([
                    this.$store.getters.api.get(`${slug}/vehicle-entries/calendar${time}`),
                    this.$store.getters.api.get(`${slug}/guestbooks/calendar${time}`)
                ])
                .then(res => {
                    const vehicleRes = res[0];
                    const guestbookRes = res[1];

                    let events = []

                    const today = new Date();
                    today.setHours(0,0,0,0);

                    if (this.showVehicles) {
                        events.push(
                            ...vehicleRes.data.map(ev => ({
                                ...ev,
                                editable: ev.status_name === "reserved"
                            }))
                        );
                    }

                    if (this.showGuestbooks) {
                        events.push(
                            ...guestbookRes.data.map(ev => ({
                                ...ev,
                                editable: ev.status_name === "reserved"
                            }))
                        );
                    }

                    if (lastCheck) {
                        this.calendarOptions.events.push(...events);
                    } else {
                        this.calendarOptions.events = events;
                    }
                })
                .catch(error => {
                    console.error("Error loading calendar events", error);
                });
            },
            changeCommodityReal(id, value) {
                const payload = {
                    end_quantity: value,
                }

                const slug = this.$route.params.slug;
                const url = `/${slug}/commodity/${id}/end`;

                this.$store.getters.api.patch(url, payload)
                    .then(() => {
                        this.getCalendarEvents();
                    })
                    .catch(error => {
                        console.error("Error moving event.", error);
                        info.revert();
                    });
            },
            handleEventClick(info) {
                const event = info.event;
                const type = event.extendedProps.type;

                this.selectedEvent = {
                    id: event.id,
                    title: event.title,
                    start: event.start,
                    end: event.end,
                    ...event.extendedProps
                };
                this.openModal(type)
            },
            handleEventDrop(info) {
                const event = info.event;

                const status = info.event.extendedProps.status_name;
                if (status !== "reserved") {
                    info.revert();
                    return;
                }

                const now = new Date();
                now.setHours(0,0,0,0)
                if (event.start < now) {
                    info.revert();
                    return;
                }

                const payload = {
                    start: event.start.toISOString(),
                    end: event.end ? event.end.toISOString() : null,
                }

                const slug = this.$route.params.slug;
                const type = event.extendedProps.type;

                const url = type === "vehicle"
                    ? `/${slug}/vehicle-entries/${event.id}/move`
                    : `/${slug}/guestbooks/${event.id}/move`;

                this.$store.getters.api.patch(url, payload)
                    .then(() => {
                        this.getCalendarEvents();
                    })
                    .catch(error => {
                        console.error("Error moving event.", error);
                        info.revert();
                    });
            },

            openModal(type) {
                if (type === "vehicle") {
                    this.vehicleModal.show()
                } else if (type === "guestbook") {
                    this.guestbookModal.show()
                }
            },
            updateCalendarEvent() {
                this.getCalendarEvents();
            },
            showDelete() {
                this.$nextTick(() => {
                    this.$refs.deleteModal.show();
                })
            },
            goToDetail(event) {
                const slug = this.$route.params.slug;

                const routeName = event.type === "vehicle"
                    ? "vehicleEntryDetailView"
                    : "guestbookDetailView";

                this.$router.push({
                    name: routeName,
                    params: {
                        slug: slug,
                        id: event.id
                    }
                })
            },
            goToEdit(event) {
                const slug = this.$route.params.slug;

                const routeName = event.type === "vehicle"
                    ? "vehicleEntryEditView"
                    : "guestbookEditView";

                this.$router.push({
                    name: routeName,
                    params: {
                        slug: slug,
                        id: event.id
                    }
                })
            },
            getDate() {
                if (this.$refs.calendar) {
                    var date = this.$refs.calendar.getApi().getDate()
                    var year = date.getFullYear();
                    var month = String(date.getMonth() + 1).padStart(2, '0');
                    var day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                }
                return ""
            }
        },
        computed: {
            canEdit() {
                const record = this.selectedEvent;
                if (!record) return false;

                const status = record.status_name;

                const canChange =
                    this.$store.getters.hasGatehousePerm(
                        record.type === "vehicle" ? "change_vehicleentry" : "change_guestbook"
                    );

                const canBeforeChange =
                    this.$store.getters.hasGatehousePerm(
                        record.type === "vehicle" ? "before_change_vehicleentry" : "before_change_guestbook"
                    );

                if (status === "left") {
                    return canChange;
                }

                if (status === "reserved" || status === "arrived") {
                    return canBeforeChange || canChange;
                }

                return false;
            },
        },
        watch: {
            '$route.params.slug'() {
                this.getCalendarEvents()
            },
            showVehicles(value) {
                localStorage.setItem("showVehicles", value)
                this.getCalendarEvents()
            },
            showGuestbooks(value) {
                localStorage.setItem("showGuestbooks", value)
                this.getCalendarEvents()
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/abstracts/variables";

    #calendar :deep(.fc-toolbar-title) {
        color: $black;
        font-weight: bold;
        text-transform: capitalize;
    }

    #calendar :deep(.fc-timegrid-slot) {
        color: $black;
        line-height: 200px;
    }

    :deep(.fc-daygrid-day-top) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :deep(.fc-daygrid-day-number) {
        color: $black;
        text-decoration: none;
    }
    :deep(.fc-col-header-cell-cushion) {
        text-decoration: none;
        color: $black;
    }

    .filter_switch {
        .form-check-input {
            width: 60px;
            height: 30px;
            cursor: pointer;
        }
        .form-check-label {
            margin-left: 15px;
            font-size: 20px;
            cursor: pointer;
        }
    }
</style>